import React from "react";
import "./Checkbox.css";

const Checkbox = (props) => {
	//caso não seja passado o handler via prop
	const handleChange = () => { };

	return (
		<label
			className={`input-checkbox-label ${props.className}`}
			style={{
				display: props.hidden ? "none" : "inline-flex",
				width: props.inputWidth || "",
				...props.style,
			}}
		>
			<span
				style={{
					minWidth: props.minWidthLabel || "",
					color: 'var(--textColor)'
				}}
			>
				{props.labelText}
			</span>
			<input
				name={props.name}
				defaultChecked={props.defaultChecked}
				checked={props.checked}
				className="input-checkbox-icon"
				onChange={props.onChange || handleChange}
				type="checkbox"
				required={props.required || false}
				disabled={props.disabled || false}
			/>
		</label>
	);
};

export default Checkbox;
